module.exports = __webpack_public_path__ + "img/1045479.e1d4181.svg";